import { UserContext } from 'contexts/ConfigContext';
import { createContext, useContext, useState } from 'react';
import { getConfig } from 'utils/helperMethods';

type ProfitPoolEvolutionContextValue = {
    evolutionFrequency: string;
    setEvolutionFrequency: (frequency: string) => void;
};

const ProfitPoolEvolutionContext = createContext<ProfitPoolEvolutionContextValue | null>(null);

export const ProfitPoolEvolutionContextProvider = ({ children }: { children: React.ReactNode }) => {
    const { appConfig } = useContext(UserContext);
    const profitPoolConfig = getConfig('profitPool', appConfig);
    const { defaultEvolutionFrequency } = profitPoolConfig;

    const [evolutionFrequency, setEvolutionFrequency] = useState<string>(defaultEvolutionFrequency || 'M');

    const value: ProfitPoolEvolutionContextValue = {
        evolutionFrequency,
        setEvolutionFrequency,
    };

    return <ProfitPoolEvolutionContext.Provider value={value}>{children}</ProfitPoolEvolutionContext.Provider>;
};

export const useProfitPoolEvolutionContext = () => {
    const context = useContext(ProfitPoolEvolutionContext);
    if (!context) {
        throw new Error('useProfitPoolEvolutionContext must be used within a ProfitPoolEvolutionContextProvider');
    }
    return context;
};
